<template>
  <div
    class="d-flex justify-content-center"
    style="min-height: 600px;height: 85vh; max-height: 85vh;"
  >
    <div v-if="!documentNumber || status" class="d-flex w-100">
      <div
        :style="{ background: status.color }"
        class="rounded-left mr-4"
        style="width:320px; flex-shrink: 0; overflow-y: auto; overflow-x: hidden;"
      >
        <div class="text-center px-3 py-3">
          <h4 class="m-0">
            <span v-if="status.id === 'draft'">Nueva</span> Orden de Producción
          </h4>
          <p
            class="font-italic text-xs m-0 font-weight-normal"
            v-if="status.id !== 'draft'"
          >
            {{ status.text }} - {{ types[form.ProductionOrderType] || form.ProductionOrderType }}
          </p>
          <p
            class="text-xs m-0 font-weight-normal"
            v-if="status.id !== 'draft'"
          >
            <b>No. </b>{{ documentNumber }}
          </p>
        </div>
        <section>
          <div
            class="px-3 py-1 d-flex align-items-center justify-content-between"
            style="background: rgba(166, 181, 204, 0.25)"
          >
            <h5 class="m-0">Producto</h5>
            <span v-if="status.id === 'boposClosed'" 
              class="text-xs font-weight-bold text-clickable" 
              @click="toggleLabel" 
              style="cursor: pointer;"
            >
              Ver Etiqueta
            </span>
            <OverlayPanel ref="labelPdf" appendTo="body" :baseZIndex="999">
              <div style="height: 350px; width: 350px;" class="d-flex justify-content-center align-items-center">
                <iframe v-if="srcLabel" :src="srcLabel" frameborder="0" width="100%" height="100%"></iframe>
                <base-loader v-else class="w-100" />
              </div>
            </OverlayPanel>
          </div>
          <div class="row px-3 py-1">
            <div class="col-12">
              <p class="text-xs font-weight-bold mb-0">
                Producto <span v-if="['draft', 'boposPlanned'].includes(status.id)">*</span>
              </p>
              <p
                class="text-xs mb-2 font-weight-normal"
                v-if="['boposReleased', 'boposClosed'].includes(status.id) && form.selItem"
              >
                <span>{{ form.selItem.ItemCode }}</span>
                <br />
                <span>{{ form.selItem.ItemName }}</span>
              </p>
              <multiselect
                v-else
                v-model="form.selItem"
                :options="items || []"
                :customLabel="(x) => `${x.ItemCode} ${x.ItemName}`"
                :loading="!items"
                class="mb-2 small-multiselect mt-1"
                placeholder="Seleccionar Producto"
                :show-labels="false"
                :allow-empty="false"
                :options-limit="20"
                @input="fillDefaults"
              >
                <template #option="{ option }">
                  <b>{{ option.ItemCode }}</b>
                  <br />
                  <span>{{ option.ItemName }}</span>
                </template>
                <template #singleLabel="{ option }">
                  <b>{{ option.ItemCode }}</b>
                  <br />
                  <span>{{ option.ItemName }}</span>
                </template>
              </multiselect>
            </div>
            <div class="col-12">
              <p class="text-xs font-weight-bold mb-0">
                Cantidad Planificada <span v-if="['draft', 'boposPlanned'].includes(status.id)">*</span>
              </p>
              <p
                class="text-xs mb-2 font-weight-normal"
                v-if="['boposReleased', 'boposClosed'].includes(status.id)"
              >
                {{ form.PlannedQuantity }}
              </p>
              <base-input
                v-else
                v-model="form.PlannedQuantity"
                type="number"
                placeholder="Cantidad"
                inputClasses="input-group-alternative form-control-sm text-xs"
                class="mb-2 mt-1"
                min="1"
                @input="calculatePlannedQty"
              />
            </div>
          </div>
        </section>
        <section>
          <div
            class="px-3 py-1 d-flex align-items-center"
            style="background: rgba(166, 181, 204, 0.25)"
          >
            <h5 class="m-0">Generales</h5>
          </div>
          <div class="row px-3 py-1">
            <div class="col-6">
              <p class="text-xs font-weight-bold mb-0">Origen</p>
              <p class="text-xs mb-2 font-weight-normal">
                {{
                  origenes[form.ProductionOrderOrigin] ||
                    form.ProductionOrderOrigin
                }}
              </p>
            </div>
            <div class="col-6">
              <p class="text-xs font-weight-bold mb-0">Prioridad</p>
              <p class="text-xs mb-2 font-weight-normal">{{ form.Priority }}</p>
            </div>

            <div class="col-12">
              <p class="text-xs font-weight-bold mb-0">
                Almacén <span v-if="['draft', 'boposPlanned'].includes(status.id)">*</span>
              </p>
              <p
                class="text-xs mb-2 font-weight-normal"
                v-if="['boposReleased', 'boposClosed'].includes(status.id)"
              >
                {{ form.Warehouse }}
              </p>
              <multiselect
                v-else
                v-model="form.Warehouse"
                v-append-to-body
                placeholder="Seleccionar Almacén"
                :options="warehouses || []"
                :loading="!warehouses"
                class="mb-2 small-multiselect mt-1"
                :show-labels="false"
                :allow-empty="false"
              />
            </div>
          </div>
        </section>
        <section>
          <div
            class="px-3 py-1 d-flex align-items-center"
            style="background: rgba(166, 181, 204, 0.25)"
          >
            <h5 class="m-0">Fechas</h5>
          </div>
          <div class="row px-3 py-1">
            <div class="col-12">
              <p class="text-xs font-weight-bold mb-0">
                Fecha de Inicio <span v-if="['draft', 'boposPlanned'].includes(status.id)">*</span>
              </p>
              <p
                class="text-xs mb-2 font-weight-normal"
                v-if="['boposReleased', 'boposClosed'].includes(status.id)"
              >
                {{ form.StartDate }}
              </p>
              <flat-picker
                v-else
                v-model="form.StartDate"
                :config="{ allowInput: true }"
                style="cursor: pointer"
                class="form-control input-group-alternative form-control-sm text-xs datepicker mb-2 mt-1"
                placeholder="Fecha de inicio"
              />
            </div>

            <div class="col-12">
              <p class="text-xs font-weight-bold mb-0">
                Fecha de Término <span v-if="['draft', 'boposPlanned'].includes(status.id)">*</span>
              </p>
              <p
                class="text-xs mb-2 font-weight-normal"
                v-if="['boposReleased', 'boposClosed'].includes(status.id)"
              >
                {{ form.DueDate }}
              </p>
              <flat-picker
                v-else
                v-model="form.DueDate"
                :config="{ allowInput: true }"
                style="cursor: pointer"
                placeholder="Fecha de término"
                class="form-control input-group-alternative form-control-sm text-xs datepicker mb-2 mt-1"
              />
            </div>
            <div class="col-12">
              <p class="text-xs font-weight-bold mb-0">Fecha del Pedido</p>
              <p class="text-xs mb-2 font-weight-normal">
                {{ form.CreationDate }}
              </p>
            </div>
            <div class="col-12">
              <p class="text-xs font-weight-bold mb-0">Fecha de Enrutamiento</p>
              <p class="text-xs mb-2 font-weight-normal">
                {{
                  enrutamientos[form.RoutingDateCalculation] ||
                    form.RoutingDateCalculation
                }}
              </p>
            </div>
          </div>
        </section>
      </div>
      <div class="d-flex flex-column flex-grow-1" style="overflow: hidden;padding: 0 2px;">
        <div class="row" style="flex-shrink: 0;">
          <div class="col-3">
            <p class="text-xs font-weight-bold mb-0">
              Categoría <span v-if="['draft', 'boposPlanned'].includes(status.id)">*</span>
            </p>
            <p class="text-xs mb-2 font-weight-normal" v-if="['boposReleased', 'boposClosed'].includes(status.id) && form.selCategory">
              {{ form.selCategory.name }}
            </p>
            <multiselect
              v-else
              v-model="form.selCategory"
              :options="categorias"
              track-by="id"
              label="name"
              class="mb-2 small-multiselect mt-1"
              placeholder="Seleccionar Categoría"
              :show-labels="false"
              @input="changePriority"
            />
          </div>
          <div class="col-3">
            <p class="text-xs font-weight-bold mb-0">
              ML <span v-if="['draft', 'boposPlanned'].includes(status.id)">*</span>
            </p>
            <p class="text-xs mb-2 font-weight-normal" v-if="['boposReleased', 'boposClosed'].includes(status.id)">
              {{ form.U_LinearMeters }}
            </p>
            <base-input
              v-else
              v-model="form.U_LinearMeters"
              type="number"
              placeholder="ML"
              inputClasses="input-group-alternative form-control-sm text-xs"
              class="mb-2 mt-1"
              min="1"
            />
          </div>
          <div class="col-3">
            <p class="text-xs font-weight-bold mb-0">
              Ancho <span v-if="['draft', 'boposPlanned'].includes(status.id)">*</span>
            </p>
            <p class="text-xs mb-2 font-weight-normal" v-if="['boposReleased', 'boposClosed'].includes(status.id)">
              {{ form.U_Width }}
            </p>
            <base-input
              v-else
              v-model="form.U_Width"
              type="number"
              placeholder="Ancho"
              inputClasses="input-group-alternative form-control-sm text-xs"
              class="mb-2 mt-1"
              min="1"
            />
          </div>
          <div class="col-3">
            <p class="text-xs font-weight-bold mb-0">
              M2 <span v-if="['draft', 'boposPlanned'].includes(status.id)">*</span>
            </p>
            <p class="text-xs mb-2 font-weight-normal" v-if="['boposReleased', 'boposClosed'].includes(status.id)">
              {{ form.U_SquareMeters }}
            </p>
            <base-input
              v-else
              v-model="form.U_SquareMeters"
              placeholder="M2"
              type="number"
              inputClasses="input-group-alternative form-control-sm text-xs"
              class="mb-2 mt-1"
            />
          </div>
        </div>
        <div class="d-flex flex-column flex-grow-1"  style="overflow: hidden;padding: 0 2px;">
          <div class="d-flex justify-content-between my-3" style="flex-shrink: 0;">
            <h5>
              {{["draft", "boposPlanned"].includes(status.id) ? "Componentes" : "Selección de Número de Lote"}}
            </h5>
            <base-button
              v-if="['draft', 'boposPlanned'].includes(status.id)"
              size="sm"
              icon="fa fa-plus"
              @click="$emit('openComponent', {
                firstPlannedQty: form.PlannedQuantity,
                addedComponents: tableComponents.map((x) => x.item.ItemCode),
              })"
              type="primary"
              outline
              :disabled="!form.selItem || !tableComponents"
            >
              Nuevo Componente
            </base-button>
            <base-input
              v-if="status.id === 'boposReleased'"
              v-model="form.lote"
              placeholder="Nuevo Lote *"
              inputClasses="input-group-alternative form-control-sm text-xs"
              class="m-0"
              style="width: 230px;"
            />
          </div>
          <div class="mb-3 flex-grow-1 d-flex flex-column" style="overflow-y: auto;">
            <div class="" >
              <table class="table table-hover m-0">
                <thead style="background-color: #f6f9fc; color:#8898AA;">
                  <tr>
                    <th rowspan="2" class="py-1 px-2"></th>
                    <th
                      rowspan="2"
                      class="py-1 px-2 text-xs"
                      style="letter-spacing: normal; text-transform: none;"
                    >
                      # Componente
                    </th>
                    <th
                      rowspan="2"
                      class="py-1 px-2 text-xs text-center"
                      style="letter-spacing: normal; text-transform: none;"
                    >
                      Almacén <span v-if="['draft', 'boposPlanned'].includes(status.id)">*</span> <br> (Materia Prima)
                    </th>
                    <th
                      colspan="3"
                      class="py-1 px-2 text-xs text-center border-right border-left border-bottom"
                      style="letter-spacing: normal; text-transform: none;"
                    >
                      Cantidad
                    </th>
                    <th v-if="['draft', 'boposPlanned'].includes(status.id)"
                      rowspan="2"
                      class="py-1 px-2 text-xs text-center"
                      style="letter-spacing: normal; text-transform: none;"
                    >
                      Stock
                    </th>
                    <th v-if="status.id === 'boposReleased'"
                      rowspan="2"
                      class="py-1 px-2 text-xs text-center"
                      style="letter-spacing: normal; text-transform: none;"
                    >
                      Total <br> Seleccionado
                    </th>
                    <th v-if="status.id === 'boposReleased'"
                      rowspan="2"
                      class="py-1 px-2 text-xs text-center"
                      style="letter-spacing: normal; text-transform: none;"
                    >
                    Cantidad <br> de Lotes
                    </th>
                    <th v-if="['boposReleased', 'boposClosed'].includes(status.id)"
                      rowspan="2"
                      class="py-1 px-2 text-xs"
                      style="letter-spacing: normal; text-transform: none;"
                    >
                      Sentido
                    </th>
                  </tr>
                  <tr>
                    <th
                      class="py-1 px-2 text-xs border-left text-right"
                      style="letter-spacing: normal; text-transform: none;"
                    >
                      Base
                    </th>
                    <th
                      class="py-1 px-2 text-xs text-right"
                      style="letter-spacing: normal; text-transform: none;"
                    >
                      Adicional
                    </th>
                    
                    <th
                      class="py-1 px-2 text-xs text-right border-right"
                      style="letter-spacing: normal; text-transform: none;"
                    >
                      Planificada
                    </th>

                  </tr>
                </thead>
                <tbody
                  v-for="(component, index) in tableComponents"
                  :key="component.item.ItemCode"
                >
                  <tr class="">
                    <td class="py-2 px-2 text-xs text-center align-middle">
                      <div
                        v-if="['draft', 'boposPlanned'].includes(status.id)"
                        @click="$emit('openComponent', {
                          component: component,
                          firstPlannedQty: form.PlannedQuantity,
                          addedComponents: tableComponents.map((x) => x.item.ItemCode).filter(x => x !== component.item.ItemCode),
                        })"
                        class="chevron-clickable d-flex align-items-center justify-content-center rounded-circle"
                        style="height: 30px; width: 30px; cursor: pointer; transition: 0.2s;"
                      >
                        <i class="fas fa-pen text-gray"></i>
                      </div>
                      <div
                        v-else-if="status.id === 'boposReleased'"
                        @click="show(component.item.ItemCode)"
                        v-b-toggle="`collapse-${component.item.ItemCode}`"
                        class="chevron-clickable d-flex align-items-center justify-content-center rounded-circle"
                        style="height: 30px; width: 30px; cursor: pointer; transition: 0.2s;"
                        :class="{
                          collapsed: openChevrons.includes(
                            component.item.ItemCode
                          ),
                        }"
                      >
                        <i class="fa fa-chevron-down collapse-icon"></i>
                      </div>
                    </td>
                    <td
                      class="py-2 px-2 text-xs align-middle"
                      style="text-overflow:ellipsis; overflow: hidden; max-width:190px; min-width: 190px;"
                    >
                      <b>{{ component.item.ItemCode }}</b>
                      <br />
                      <span :title="component.item.ItemName">
                        {{ component.item.ItemName }}
                      </span>
                    </td>
                    <td
                      class="py-2 px-2 text-xs align-middle text-center border-0"
                    >
                      <span v-if="['boposReleased', 'boposClosed'].includes(status.id)">
                        {{component.Warehouse}}
                      </span>
                      <div v-else class=" d-flex align-items-center justify-content-center">
                        <multiselect
                          v-model="component.Warehouse"
                          :options="warehouses || []"
                          :loading="!warehouses"
                          class="small-multiselect"
                          v-append-to-body
                          :show-labels="false"
                          placeholder="Almacén"
                          style="width: 130px;"
                          :allow-empty="false"
                          @input="(x) => updateStock(x, component.item.ItemCode)"
                        />
                      </div>
                    </td>
                    <td
                      class="py-2 px-2 text-xs align-middle text-right" style="letter-spacing: 1px;"
                    >
                      {{ numberFormat(component.BaseQuantity, 5) }}
                    </td>
                    <td
                      class="py-2 px-2 text-xs align-middle text-right" style="letter-spacing: 1px;"
                    >
                      {{ numberFormat(component.AdditionalQuantity, 5) }}
                    </td>
                    <td
                      class="py-2 px-2 text-xs align-middle text-right" style="letter-spacing: 1px;"
                    >
                      {{ numberFormat(component.PlannedQuantity, 5) }}
                    </td>
                    <td v-if="['draft', 'boposPlanned'].includes(status.id)"
                      class="py-2 px-2 text-xs align-middle text-center font-weight-bold"
                    >
                      <span class="badge text-xs" :class="component.stock > 0 ? 'badge-success' : 'badge-danger'">
                        {{ numberFormat(component.stock) }}
                      </span>
                    </td>
                    <td v-if="status.id === 'boposReleased'"
                      class="py-2 px-2 text-xs align-middle text-center font-weight-bold" style="letter-spacing: 1px;"
                    >
                      <span 
                        class="badge text-xs" 
                        :class="component.totalBatches === component.PlannedQuantity ? 'badge-success' : 'badge-danger'"
                        tabindex="0"
                        v-b-popover.hover.top="
                        component.totalBatches === component.PlannedQuantity ? null : 
                        `Selecciona los lotes y cantidades necesarias para igualar la Cantidad Planificada. (${numberFormat(component.PlannedQuantity, 5)})`
                      "
                      >
                        {{ numberFormat(component.totalBatches, 5) }}
                      </span>
                    </td>
                    <td v-if="status.id === 'boposReleased'"
                      class="py-2 px-2 text-xs align-middle text-center"
                    >
                      {{ component.selectedBatches.length }}
                    </td>
                    <td v-if="['boposReleased', 'boposClosed'].includes(status.id)"
                      class="py-2 px-2 text-xs align-middle font-weight-bold"
                    >
                      Salida
                    </td>
                  </tr>
                  <tr class="m-0 p-0">
                    <td colspan="100" class="p-0 border-0">
                      <b-collapse
                        :id="`collapse-${component.item.ItemCode}`"
                        @hidden="hidden(component.item.ItemCode)"
                        @hide="hide(component.item.ItemCode)"
                      >
                        <keep-alive>
                          <BatchTables
                            v-if="openRows.includes(component.item.ItemCode)"
                            :availableBatches="component.availableBatches"
                            @update="(x, y) => updateComponent(index, x, y)"
                          />
                        </keep-alive>
                      </b-collapse>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <base-loader v-if="loadingComponents" class="flex-grow-1" />
            <empty-section v-else-if="tableComponents && !tableComponents.length" class="flex-grow-1"/>
          </div>
        </div>
        <div v-if="status.id === 'draft'" class="d-flex justify-content-end" style="flex-shrink: 0;">
          <div v-if="!creating" v-b-popover.hover.focus.bottom.html="validationPopover" tabindex="0">
            <base-button
              @click="createPO()"
              icon="fa fa-check"
              :disabled="!validation.valid"
              type="primary"
            >
              Crear Orden de Producción
            </base-button>
          </div>
        </div>
        <div v-else-if="status.id === 'boposPlanned'" class="d-flex justify-content-end" style="flex-shrink: 0;">
          <div v-b-popover.hover.focus.bottom.html="validationPopover" tabindex="0">
            <base-button
              v-if="!updating"
              @click="updatePO()"
              icon="fa fa-check"
              type="primary"
              :disabled="!validation.valid"
              outline
              class="mr-3"
            >
              Guardar Cambios
            </base-button>
          </div>
          <div v-b-popover.hover.focus.bottom.html="validationPopover" tabindex="0">
            <base-button
              v-if="!updating"
              @click="releasePO()"
              icon="fa fa-arrow-right"
              type="primary"
              :disabled="!validation.valid"
            >
              Guardar y Liberar 
            </base-button>
          </div>
        </div>
        <div v-else-if="status.id === 'boposReleased'" class="d-flex justify-content-end" style="flex-shrink: 0;">
          <div v-b-popover.hover.focus.bottom.html="validationPopover" tabindex="0">
            <base-button
              v-if="!closing"
              @click="closePO"
              icon="fa fa-check"
              type="success"
              :disabled="!validation.valid"
            >
              Crear Recibo de Producción
            </base-button>
          </div>
        </div>
      </div>
    </div>
    <base-loader v-else />
    <Overlay v-if="creating || updating || closing">
      <base-loader v-if="creating" text="Creando Orden de Producción" class="mx-4 flex-grow-1"/>
      <base-loader v-else-if="updating" text="Actualizando Orden de Producción" class="mx-4 flex-grow-1"/>
      <base-loader v-else-if="closing" text="Cerrando Orden de Producción" class="mx-4 flex-grow-1"/>
    </Overlay>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Multiselect from "vue-multiselect";
import flatPicker from "vue-flatpickr-component";
import EmptySection from "@/components/EmptySection.vue";
import BaseLoader from "@/components/BaseLoader.vue";
import BatchTables from "./BatchTables.vue";
import Formats from "@/mixins/Formats";
import { getAuth } from "firebase/auth";
import Overlay from "@/components/Overlay.vue";
import appendToBody from '@/directives/appendToBody';
import OverlayPanel from 'primevue/overlaypanel';

export default {
  mixins: [Formats],
  directives: {
    appendToBody,
  },
  components: {
    Multiselect,
    flatPicker,
    EmptySection,
    BaseLoader,
    BatchTables,
    Overlay,
    OverlayPanel,
  },
  props: {
    documentNumber: {
      type: [Number, String],
    },
    warehouses: {
      type: Array,
    },
    components: {
      type: Array,
    },
  },
  data() {
    return {
      BASE_URL: process.env.VUE_APP_BASE_URL,
      HANA_URL: process.env.VUE_APP_HANA_URL,
      user: null,
      openRows: [],
      openChevrons: [],
      status: null,
      statuses: [
        { id: "draft", color: "#dcefff", text: null },
        { id: "boposPlanned", color: "#c8e5ff", text: "Planificado" },
        { id: "boposReleased", color: "#d0f9e7", text: "Liberado" },
        { id: "boposClosed", color: "#f6f9fc", text: "Cerrado" },
      ],
      form: {
        AbsoluteEntry: null,
        selItem: null,
        PlannedQuantity: null,
        Warehouse: null,
        StartDate: null,
        DueDate: null,
        selCategory: null,
        U_LinearMeters: null,
        U_Width: null,
        U_SquareMeters: null,
        lote: null,
        CreationDate: null,
        RoutingDateCalculation: null,
        ProductionOrderOrigin: null,
        Priority: null,
        ProductionOrderType: null,
      },
      items: null,
      tableComponents: null,
      loadingComponents: false,
      origenes: { bopooManual: "Manual" },
      enrutamientos: { raOnStartDate: "En fecha de inicio" },
      categorias: [{ id: "0", name: "Fix" }, { id: "1", name: "Flex" }],
      types: { bopotStandard: "Estándar"},
      creating: false,
      updating: false,
      closing: false,
      srcLabel: null,
    };
  },
  created() {
    const {displayName, email} = getAuth().currentUser;
    this.user = {displayName, email};
    this.loadPO();
    axios
      .get(`/api/items/list/ext`)
      .then((res) => {
        this.items = res.data;
      })
      .catch((err) => {
        console.error(err);
      });
  },
  methods: {
    toggleLabel(event){
      this.$refs.labelPdf.toggle(event);
      if(!this.srcLabel){
        const json = {
          "DocCode": "IGN20006",
          "Pairs": {
              "DocKey@": this.documentNumber
          }
        };
        axios.post(`/api/pdf_file`,json)
          .then(res => {
            if(res.data.base64){
              this.srcLabel = res.data.base64;
            } else if(res.data.se_err){
              this.$swal("Error", res.data.se_err.message, "error");
            } else {
              this.$swal("Error", "No se pudo obtener la etiqueta", "error");
              console.error("Error", res.data)
            }
          }).catch(error => {
            console.error(error); 
          });
      }
    },
    loadPO(){
      if (this.documentNumber) {
        this.loadingComponents = true;
        axios
          .get(`/api/production_orders/by/doc_num/${this.documentNumber}`)
          .then((res) => {
            if(
              res.data.value.length && 
              res.data.value[0].ProductionOrderStatus !== "boposCancelled" && 
              res.data.value[0].Project === "EXT"
            ){
              const order = res.data.value[0];
              console.log("Orden de Producción", order);

              this.form.AbsoluteEntry = order.AbsoluteEntry;
              this.form.selItem = {
                ItemCode: order.ItemNo,
                ItemName: order.ProductDescription,
              };
              this.status = this.statuses.find(
                (x) => x.id === order.ProductionOrderStatus
              );
              this.form.PlannedQuantity = order.PlannedQuantity;
              this.form.Warehouse = order.Warehouse;
              this.form.StartDate = order.StartDate;
              this.form.DueDate = order.DueDate;
              this.form.CreationDate = order.CreationDate;
              this.form.RoutingDateCalculation = order.RoutingDateCalculation;
              this.form.selCategory = this.categorias.find(
                (x) => x.id === order.U_Category
              );
              this.form.U_LinearMeters = order.U_LinearMeters;
              this.form.U_Width = order.U_Width;
              this.form.U_SquareMeters = order.U_SquareMeters;
              this.form.ProductionOrderOrigin = order.ProductionOrderOrigin;
              this.form.Priority = order.Priority;
              this.form.ProductionOrderType = order.ProductionOrderType;

              const requestsStock = order.ProductionOrderLines.map((x) => {
                return axios.post(`${this.HANA_URL}/api/hana/basic_general_query`, {
                  select: `"ItemCode", "WhsCode", "BatchNum", "Quantity"`,
                  table: "OIBT",
                  where: `WHERE "Quantity" > 0 AND "WhsCode" = '${
                    x.Warehouse
                  }' AND "ItemCode" = '${x.ItemNo}'`,
                });
              });

              axios
                .all(requestsStock)
                .then(
                  axios.spread((...responses) => {
                    const assignAfterComponentsLoaded = () => {
                      this.tableComponents = order.ProductionOrderLines.map(
                        (x, index) => {
                          return {
                            item: this.components.find((i) => i.ItemCode === x.ItemNo),
                            Warehouse: x.Warehouse,
                            BaseQuantity: x.BaseQuantity,
                            AdditionalQuantity: x.AdditionalQuantity,
                            BaseLine: x.LineNumber,
                            PlannedQuantity: x.PlannedQuantity,
                            stock: responses[index].data.reduce(
                              (acc, curr) => acc + parseFloat(curr.Quantity) || 0,
                              0
                            ),
                            totalBatches: 0,
                            selectedBatches: [],
                            availableBatches: responses[index].data.map((y) => {
                              return {
                                BatchNum: y.BatchNum,
                                Quantity: parseFloat(y.Quantity),
                                selected: parseFloat(y.Quantity),
                              };
                            }),
                          };
                        }
                      );
                      this.loadingComponents = false;
                    };
                    if (this.components && this.components.length) {
                      assignAfterComponentsLoaded();
                    } else {
                      this.watchComponents = this.$watch(() => this.components, (newVal) => {
                        if (newVal && newVal.length) {
                          assignAfterComponentsLoaded();
                          this.watchComponents(); // Remove watcher
                        }
                      });
                    }
                  })
                )
                .catch((err) => {
                  console.error(err);
                });
              } else {
                this.$emit("close");
                this.$swal({
                  text: `La Orden #${this.documentNumber} no existe o ha sido cancelada.`,
                  icon: "warning",
                  timer: 3000,
                });
              }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        this.tableComponents = [];
        this.status = this.statuses.find((x) => x.id === "draft");
        this.form.StartDate = moment().format("YYYY-MM-DD");
        this.form.DueDate = moment().format("YYYY-MM-DD");
        this.form.CreationDate = moment().format("YYYY-MM-DD");
        this.form.RoutingDateCalculation = "raOnStartDate";
        this.form.ProductionOrderOrigin = "bopooManual";
      }
    },
    resetData(){
      this.status = null;
      this.openRows = [];
      this.openChevrons = [];
      this.tableComponents = null;
      Object.keys(this.form).forEach((key) => {
        this.form[key] = null;
      });
    },
    updateComponent(index, selectedBatches) {
      this.$set(this.tableComponents, index, {
        ...this.tableComponents[index],
        selectedBatches: selectedBatches,
        totalBatches: selectedBatches.reduce((acc, row) => acc + (row.selected || 0), 0),
      });
    },
    show(id) {
      this.openRows.push(id);
      this.openChevrons.push(id);
    },
    hidden(id) {
      this.openRows = this.openRows.filter((row) => row !== id);
    },
    hide(id) {
      this.openChevrons = this.openChevrons.filter((row) => row !== id);
    },
    openStock() {
      this.$emit("openStock", true);
    },
    fillDefaults(data) {
      this.loadingComponents = true;
      this.tableComponents = null;
      this.openRows = [];
      this.openChevrons = [];
      axios
        .get(`/api/items/components?ItemCode=${data.ItemCode}`)
        .then((res) => {
          const requests = res.data.value.map((x) => {
            const itemCode = x["ProductTrees/ProductTreeLines"].ItemCode;
            const warehouse = x["ProductTrees/ProductTreeLines"].Warehouse;
            const json = {
              select: `"ItemCode", "WhsCode", "BatchNum", "Quantity"`,
              table: "OIBT",
              where: `WHERE "Quantity" > 0 AND "WhsCode" = '${warehouse}' AND "ItemCode" = '${itemCode}'`,
            };
            return axios.post(`${this.HANA_URL}/api/hana/basic_general_query`, json);
          });

          axios.all(requests).then(
            axios.spread((...responses) => {
              const stocks = responses.map((x) => {
                return x.data.reduce(
                  (acc, curr) => acc + parseFloat(curr.Quantity) || 0,
                  0
                );
              });

              if (this.components && this.components.length) {
                this.assignDefaults(res.data.value, stocks);
              } else {
                this.watchComponents = this.$watch(() => this.components, (newVal) => {
                  if (newVal && newVal.length) {
                    this.assignDefaults(res.data.value, stocks);
                    this.watchComponents(); // Remove watcher
                  }
                });
              }
            })
          );
        })
        .catch((err) => {
          console.error(err);
          this.loadingComponents = false;
        });
    },
    assignDefaults(data, stocks) {
      this.tableComponents = data.map((x, index) => {
        return {
          item: this.components.find(c => c.ItemCode === x["ProductTrees/ProductTreeLines"].ItemCode),
          Warehouse: x["ProductTrees/ProductTreeLines"].Warehouse,
          BaseQuantity: x["ProductTrees/ProductTreeLines"].Quantity,
          AdditionalQuantity: 0,
          PlannedQuantity: ((parseFloat(this.form.PlannedQuantity || 0)) * parseFloat(x["ProductTrees/ProductTreeLines"].Quantity || 0)).toFixed(5),
          stock: stocks[index],
        };
      });
      this.loadingComponents = false;
    },
    updateStock(warehouse, itemCode) {
      const json = {
        select: `"ItemCode", "WhsCode", "BatchNum", "Quantity"`,
        table: "OIBT",
        where: `WHERE "Quantity" > 0 AND "WhsCode" = '${warehouse}' AND "ItemCode" = '${itemCode}'`,
      };
      axios
        .post(`${this.HANA_URL}/api/hana/basic_general_query`, json)
        .then((res) => {
          const newStock = res.data.reduce((acc, curr) => acc + parseFloat(curr.Quantity) || 0, 0);
          const index = this.tableComponents.findIndex(x => x.item.ItemCode === itemCode);
          this.$set(this.tableComponents, index, {
            ...this.tableComponents[index],
            stock: newStock,
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    addNewComponent(data) { // used by parent component
      this.tableComponents.push(data);
      this.updateStock(data.Warehouse, data.item.ItemCode);
    },
    saveChanges(data) { // used by parent component
      const index = this.tableComponents.findIndex(x => x.item.ItemCode === data.item.ItemCode);
      this.$set(this.tableComponents, index, data);
      this.updateStock(data.Warehouse, data.item.ItemCode);
    },
    removeComponent(itemCode) { // used by parent component
      this.tableComponents = this.tableComponents.filter(x => x.item.ItemCode !== itemCode);
    },
    changePriority(data) {
      if (data.id === "0") {
        //Fix
        this.form.Priority = 100;
      } else if (data.id === "1") {
        //Flex
        this.form.Priority = 50;
      }
    },
    calculatePlannedQty(){
      if(this.tableComponents){
        this.tableComponents.forEach((x) => {
          x.PlannedQuantity = (
            (parseFloat(this.form.PlannedQuantity || 0)) * parseFloat(x.BaseQuantity || 0) + parseFloat(x.AdditionalQuantity || 0)
          ).toFixed(5);
        });
      }
    },
    createPO() {
      this.creating = true;
      const json = {
        ProductionOrderType: "bopotStandard",
        ProductionOrderStatus: "boposPlanned",
        Warehouse: this.form.Warehouse,
        Priority: this.form.Priority,
        RoutingDateCalculation: this.form.RoutingDateCalculation,
        U_Category: this.form.selCategory.id,
        ProductDescription: this.form.selItem.ItemName,
        ItemNo: this.form.selItem.ItemCode,
        PlannedQuantity: this.form.PlannedQuantity,
        InventoryUOM: "",
        U_MasterProduction: null,
        CreationDate: this.form.CreationDate,
        StartDate: this.form.StartDate,
        DueDate: this.form.DueDate,
        ProductionOrderOrigin: this.form.ProductionOrderOrigin,
        U_LinearMeters: this.form.U_LinearMeters,
        U_Width: this.form.U_Width,
        U_SquareMeters: this.form.U_SquareMeters,
        Project: "EXT",
        ProductionOrderLines: this.tableComponents.map((x) => {
          return {
            ItemNo: x.item.ItemCode,
            BaseQuantity: x.BaseQuantity,
            PlannedQuantity: x.PlannedQuantity,
            ProductionOrderIssueType: "im_Manual",
            AdditionalQuantity: x.AdditionalQuantity,
            ItemType: "pit_Item",
            Project: "EXT",
            Warehouse: x.Warehouse,
          };
        }),
      };

      axios
        .post(`api/production_orders`, json)
        .then((res) => {
          console.log("🟩 POST RESPONSE", res, json);
          if (res.data.DocumentNumber) {
            this.$emit("success");
            this.$swal({
              title: `Orden de Producción #${res.data.DocumentNumber}`,
              text: "La orden de producción ha sido creada exitosamente",
              icon: "success",
            }).then(() => {
              this.$emit("close");
            });
          } else if (res.data.se_err && res.data.se_err.error) {
            this.$swal({
              title: "Error",
              text: res.data.se_err.error.message.value,
              icon: "error",
            });
          } else {
            this.$swal({
              title: "Algo salió mal",
              text: "No se pudo crear la orden de producción",
              icon: "error",
            });
            console.error(res.data);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.creating = false;
        });
    },
    updatePO(release){
      this.updating = true;
      const json = {
        // ProductionOrderType: "bopotStandard",
        // ProductionOrderStatus: "boposPlanned",
        Warehouse: this.form.Warehouse,
        Priority: this.form.Priority,
        RoutingDateCalculation: this.form.RoutingDateCalculation,
        U_Category: this.form.selCategory.id,
        ProductDescription: this.form.selItem.ItemName,
        ItemNo: this.form.selItem.ItemCode,
        PlannedQuantity: this.form.PlannedQuantity,
        // InventoryUOM: "",
        // U_MasterProduction: null,
        CreationDate: this.form.CreationDate,
        StartDate: this.form.StartDate,
        DueDate: this.form.DueDate,
        ProductionOrderOrigin: this.form.ProductionOrderOrigin,
        U_LinearMeters: this.form.U_LinearMeters,
        U_Width: this.form.U_Width,
        U_SquareMeters: this.form.U_SquareMeters,
        ProductionOrderLines: this.tableComponents.map((x) => {
          return {
            ItemNo: x.item.ItemCode,
            BaseQuantity: x.BaseQuantity,
            PlannedQuantity: x.PlannedQuantity,
            ProductionOrderIssueType: "im_Manual",
            AdditionalQuantity: x.AdditionalQuantity,
            ItemType: "pit_Item",
            Project: "EXT",
            Warehouse: x.Warehouse,
          };
        }),
      };
      if(release){
        json.ProductionOrderStatus = "boposReleased";
      }
      axios.patch(`api/production_orders?doc_entry=${this.form.AbsoluteEntry}`, json)
      .then(res => {
        console.log("🟩 PATCH RESPONSE", res, json)
        if(res.data.success){
          this.$emit("success");
          this.$swal({
            title: `Orden de Producción #${this.documentNumber}`,
            text: "Los cambios han sido guardados exitosamente",
            icon: "success",
          });
          this.resetData();
          this.loadPO();
        } else if(res.data.se_err && res.data.se_err.error){
          this.$swal({
            title: "Error",
            text: res.data.se_err.error.message.value,
            icon: "error",
          });
        } else {
          this.$swal({
            title: "Algo salió mal",
            text: "No se pudo editar la orden de producción",
            icon: "error",
          });
          console.error(res.data);
        }
      })
      .catch(err => {
        console.error(err); 
      })
      .finally(() => {
        this.updating = false;
      });
    },
    releasePO(){
      this.$swal.fire({
        title: `Liberar Orden #${this.documentNumber}`,
        text: "Estás a punto de liberar esta orden de producción, ¿deseas continuar?",
        icon: "question",
      }).then((result) => {

        if (result.isConfirmed) {
          this.updatePO(true);
        }
      });
    },
    closePO(){
      this.$swal.fire({
        title: `Cerrar Orden #${this.documentNumber}`,
        text: "Estás a punto de crear el recibo esta orden de producción, ¿deseas continuar?",
        icon: "question",
      }).then((result) => {
        if (result.isConfirmed) {
          this.closing = true;
          const jsonExit = {
            DocumentLines: this.tableComponents.map((component) => {
              return {
                BaseEntry: this.form.AbsoluteEntry,
                Warehouse: component.Warehouse,
                BaseLine: component.BaseLine,
                Quantity: component.PlannedQuantity,
                BatchNumbers: component.selectedBatches.map((batch) => {
                  return {
                    BatchNumber: batch.BatchNum,
                    Quantity: batch.selected,
                  };
                }),
              }
            }),
            JournalMemo: "Salida manual",
            Comments: "Creado desde la consola por: " + this.user.email
          }
    
          axios
            .post(`api/inventory_gen/manual_exit`, jsonExit)
            .then(res => {
              console.log("🟧 EXIT", res, jsonExit)
    
              if(res.data.DocNum){
                const jsonEntry = {
                  DocumentLines: [{
                    BaseEntry: this.form.AbsoluteEntry,
                    Warehouse: this.form.Warehouse,
                    Quantity: this.form.PlannedQuantity,
                    BatchNumbers:[
                        {
                            BatchNumber: this.form.lote,
                            Quantity: this.form.PlannedQuantity
                        }
                    ]
                  }],
                  JournalMemo: "Entrada manual", 
                  Comments: "Creado desde la consola por: " + this.user.email
                }
    
                axios
                  .post(`api/inventory_gen/manual_entries`, jsonEntry)
                  .then(res => {
                    console.log("🟦 ENTRY", res, jsonEntry)
                    if(res.data.DocNum){
                      axios
                        .patch(
                          `api/production_orders?doc_entry=${this.form.AbsoluteEntry}`, 
                          { ProductionOrderStatus: 'boposClosed' }
                        )
                        .then(res => {
                          console.log("🟩 STATUS CLOSED", res)
                          if(res.data.success){
                            this.$emit("success");
                            this.$swal({
                              title: `Orden de Producción #${this.documentNumber}`,
                              text: "La orden de producción ha sido cerrada exitosamente",
                              icon: "success",
                            });
                            this.resetData();
                            this.loadPO();
                          } else if(res.data.se_err && res.data.se_err.error){
                            this.$swal({
                              title: "Error de Estatus",
                              text: res.data.se_err.error.message.value,
                              icon: "error",
                            });
                          } else {
                            this.$swal({
                              title: "Algo salió mal",
                              text: "No se pudo cerrar la orden de producción. Error de Estatus.",
                              icon: "error",
                            });
                            console.error(res.data);}
                        })
                        .catch(err => {
                          console.error(err);
                        })
                        .finally(() => {
                          this.closing = false;
                        })
    
    
                    } else if(res.data.se_err && res.data.se_err.error){
                      this.$swal({
                        title: "Error de Entrada",
                        text: res.data.se_err.error.message.value,
                        icon: "error",
                      });
                      this.closing = false;
                    } else {
                      this.$swal({
                        title: "Algo salió mal",
                        text: "No se pudo crear el recibo de producción. Error de Entrada.",
                        icon: "error",
                      });
                      console.error(res.data);
                      this.closing = false;
                    }
                  })
                  .catch(err => {
                    console.error(err);
                    this.closing = false;
                  });
              } else if(res.data.se_err && res.data.se_err.error){
                this.$swal({
                  title: "Error de Salida",
                  text: res.data.se_err.error.message.value,
                  icon: "error",
                });
                console.error(res.data);
                this.closing = false;
              } else {
                this.$swal({
                  title: "Algo salió mal",
                  text: "No se pudo crear el recibo de producción. Error de Salida.",
                  icon: "error",
                });
                console.error(res.data);
                this.closing = false;
              }
            })
            .catch(err => {
              console.error(err);
              this.closing = false;
            });
        }
      });
    },
  },
  computed: {
    validation() {
      const { selItem, PlannedQuantity, Warehouse, selCategory, U_LinearMeters, U_Width, U_SquareMeters } = this.form;
      let complete = {};
      if(['draft', 'boposPlanned'].includes(this.status.id)){
        complete = {
          "Producto": selItem,
          "Cantidad Planificada (Mayor a 0)": PlannedQuantity > 0,
          "Almacén": Warehouse,
          "Categoría": selCategory,
          "ML (Metros lineales)": U_LinearMeters,
          "Ancho": U_Width,
          "M2 (Metros cuadrados)": U_SquareMeters,
          "Componentes": this.tableComponents && this.tableComponents.length > 0,
          "Cantidades de Componentes": this.tableComponents && this.tableComponents.every(
            (x) =>
              x.BaseQuantity > 0 &&
              x.AdditionalQuantity >= 0 && x.AdditionalQuantity !== '' &&
              x.PlannedQuantity > 0
          ),
        };
      } else if(this.status.id === 'boposReleased'){
        complete = {
          "Nuevo Lote": this.form.lote,
          "Total de Lotes Seleccionados": this.tableComponents && this.tableComponents.every(
            (x) => x.totalBatches === x.PlannedQuantity
          ),
        }
      }
      return {
        valid: Object.values(complete).every((x) => x),
        missing: Object.keys(complete).filter((x) => !complete[x]),
      };
    },
    validationPopover() {
      if (this.validation.missing.length > 0) {
        return {
          title: "<small><b>Falta completar los campos:</b></small>",
          content: `<ul><li>${this.validation.missing.join("<li>")}</ul>`,
          placement: "righttop",
        };
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped>
.collapse-icon {
  transition: 0.2s;
}

:not(.collapsed) > .collapse-icon {
  transform: rotate(180deg);
}

.text-clickable {
  color: #5e72e4;
}
.text-clickable:hover {
  color: #4a5fda;
}

.chevron-clickable:hover {
  background: #e2e8f0;
}
</style>

<style>
.popover{
    max-width: 800px !important;
}
</style>
